<template>
  <div>
    <b-row class="justify-content-center" v-if="!loaded && loading">
      <b-spinner big label="Loading..."></b-spinner>
    </b-row>
    <h2 class="bordered-box-header" v-if="loaded">Informacje o koncie lektora</h2>
    <b-container fluid class="bordered-box" v-if="loaded">
      <b-row>
        <p class="col-12">
          <span class="font-weight-bold">Konto aktywne:</span>
          {{!locked ? "Tak" : "Nie"}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Email:</span>
          {{email}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Email potwierdzony:</span>
          {{emailConfirmed ? "Tak" : "Nie"}}
        </p>

        <p class="col-12">
          <span class="font-weight-bold">Skype:</span>
          {{skype}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Nr telefonu:</span>
          {{phoneNumber}}
        </p>
        <p class="col-12">
          <span class="font-weight-bold">Opis:</span>
          {{description}}
        </p>
        <b-col cols="12">
          <button class="btn btn-info mr-2" @click="sendEmailConfirmation" v-if="!emailConfirmed">
            <span v-show="!sendingEmail">Wyślij wiadomość do potwierdzenia adresu email</span>
            <span v-show="sendingEmail">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </button>
          <button class="btn btn-primary edit-item mr-2" @click="showEditLectorModal">Edytuj</button>
          <button v-if="!locked" class="btn btn-danger" @click="lockAccount">
            <span v-show="!locking">Zablokuj konto</span>
            <span v-show="locking">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </button>
          <button v-else class="btn btn-success" @click="unlockAccount">
            <span v-show="!locking">Odblokuj konto</span>
            <span v-show="locking">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </button>
        </b-col>
      </b-row>
    </b-container>
    <editLectorModal ref="editLectorModal" @save="onEditLector" :lector="lector" />
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import editLectorModal from "./../EditLectorModal";

export default {
  data() {
    return {
      loading: false,
      loaded: false,
      locked: null,
      firstName: null,
      lastName: null,
      skype: null,
      description: null,
      phoneNumber: null,
      email: null,
      sendingEmail: false,
      locking: false,
      emailConfirmed: null,
      lector: null
    };
  },
  computed: {
    fullName() {
      return this.firstName + " " + this.lastName;
    }
  },
  props: ["id"],
  components: {
    editLectorModal
  },
  mounted() {
    if (this.id) {
      this.loading = true;

      axios
        .get("/lectors/details/", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;
          this.loaded = true;
          this.lector = result;
          this.firstName = result.firstName;
          this.lastName = result.lastName;
          this.skype = result.skype;
          this.email = result.email;
          this.emailConfirmed = result.emailConfirmed;
          this.phoneNumber = result.phoneNumber;
          this.description = result.description;
          this.locked = result.locked;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    unlockAccount() {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz odblokować konto lektora?")
        .then(value => {
          if (value) {
            this.onSubmitLock(false);
          }
        });
    },
    lockAccount() {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz zablokować konto lektora?")
        .then(value => {
          if (value) {
            this.onSubmitLock(true);
          }
        });
    },
    onSubmitLock(val) {
      this.locking = true;
      axios
        .post("/lectors/lock", {
          userId: this.id,
          lock: val
        })
        .then(() => {
          eventBus.$emit(
            "notify-success",
            val ? "Konto zablokowane" : "Konto odblokowane"
          );
          this.locked = val;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.locking = false;
        });
    },
    sendEmailConfirmation() {
      this.$bvModal
        .msgBoxConfirm(
          "Czy na pewno chcesz ponownie wysłać wiadomość z linkiem aktywacyjnym?"
        )
        .then(value => {
          if (value) {
            this.onSubmitSendEmailConfirmation();
          }
        });
    },
    onSubmitSendEmailConfirmation() {
      this.sendingEmail = true;
      axios
        .post("/auth/resendEmailConfirmation", {
          id: this.id
        })
        .then(() => {
          eventBus.$emit("notify-success", "Wysłano wiadomość");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.sendingEmail = false;
        });
    },
    showEditLectorModal() {
      this.$refs.editLectorModal.show();
    },
    onEditLector(r) {
      let self = this;

      axios["put"]("/lectors", {
        id: r.id,
        firstName: r.firstName,
        lastName: r.lastName,
        skype: r.skype,
        phoneNumber: r.phoneNumber,
        email: this.email,
        description: r.description
      })
        .then(() => {
          self.firstName = r.firstName;
          self.lastName = r.lastName;
          self.skype = r.skype;
          self.phoneNumber = r.phoneNumber;
          self.description = r.description;

          self.lector.firstName = r.firstName;
          self.lector.lastName = r.lastName;
          self.lector.skype = r.skype;
          self.lector.phoneNumber = r.phoneNumber;
          self.lector.description = r.description;

          eventBus.$emit("notify-success", "Zapisano poprawnie.");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => (this.saving = false));
    }
  }
};
</script>

<style lang="scss" scoped>
h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>